"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerQuery = exports.CustomerInput = exports.CustomerCreateInput = exports.CustomerTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const address_transport_1 = require("./address-transport");
const customer_contact_transport_1 = require("./customer-contact-transport");
const customer_type_1 = require("./customer-type");
const service_location_transport_1 = require("./service-location-transport");
const wayste_customer_document_transport_1 = require("./wayste-customer-document-transport");
exports.CustomerTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Boolean(),
    displayName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerNumber: typebox_1.Type.Integer(),
    allowWaysteDashboardAccess: typebox_1.Type.Boolean(),
    accessToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    billingAddress: address_transport_1.AddressTransport,
    companyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    contacts: typebox_1.Type.Array(customer_contact_transport_1.CustomerContactTransport),
    documents: typebox_1.Type.Array(wayste_customer_document_transport_1.WaysteCustomerDocumentTransport),
    serviceLocations: typebox_1.Type.Array(service_location_transport_1.ServiceLocationTransport),
    taxExempt: typebox_1.Type.Boolean(),
    type: typebox_1.Type.Optional(customer_type_1.CustomerType),
    stripeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentTerm: typebox_1.Type.Integer({ minimum: 0 }),
    paymentMethod: common_1.PaymentMethod,
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.CustomerCreateInput = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CustomerTransport, [
        'id',
        'customerNumber',
        'haulerID',
        'metadata',
        'accessToken',
        'allowWaysteDashboardAccess',
        'accessToken',
        'contacts',
        'documents',
        'displayName',
        'paymentTerm',
        'paymentMethod',
    ]),
    typebox_1.Type.Object({
        contacts: typebox_1.Type.Array(customer_contact_transport_1.WaysteCustomerContactCreate, { minItems: 1 }),
        paymentTerm: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
        paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
        notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    }),
]);
exports.CustomerInput = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CustomerTransport, [
        'id',
        'customerNumber',
        'haulerID',
        'metadata',
        'accessToken',
        'contacts',
        'documents',
        'displayName',
        'paymentTerm',
        'paymentMethod',
    ]),
    typebox_1.Type.Object({
        rotateAccessToken: typebox_1.Type.Boolean(),
        contacts: typebox_1.Type.Optional(typebox_1.Type.Array(customer_contact_transport_1.WaysteCustomerContactUpdate)),
        paymentTerm: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
        paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
    }),
]));
exports.CustomerQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String(), // Comma separated list of customerIDs
        email: typebox_1.Type.String({ format: 'email' }),
    }),
]));
//# sourceMappingURL=customer-transport.js.map